@if (agreementrequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
    <app-dialog-input-title title="Kunde"
                            [required]="true"></app-dialog-input-title>
    <select [(ngModel)]="agreementrequest.clientId"
            (ngModelChange)="clientCascade($event)">
      <option value="0" class="hidden">Vælg Kunde</option>
      @for (client of clients; track client.id) {
      <option [ngValue]="client.id">
        {{ client.name }}
      </option>
      }
    </select>
    @if(agreementrequest.clientId > 0 && shownPlants.length > 0){
    <app-dialog-input-title title="Anlæg"></app-dialog-input-title>
    <select [(ngModel)]="agreementrequest.plantId">
      <option [ngValue]="null">(Intet Anlæg valgt)</option>
      @for (plant of shownPlants; track plant.id) {
      <option [ngValue]="plant.id">
        {{ plant.plantName }}
      </option>
      }
    </select>
    }

    <app-dialog-input-title title="Sidste invoice Dato"></app-dialog-input-title>
    <mat-form-field (click)="LastDatePicker.open()">
      <mat-label>Vælg dato</mat-label>
      <input matInput
             [matDatepicker]="LastDatePicker"
             [(ngModel)]="agreementrequest.lastInvoiceDate"
             name="LastInvoiceDate"
             #LastInvoiceInputDate />
      <mat-datepicker-toggle matSuffix
                             [for]="LastDatePicker"></mat-datepicker-toggle>
      @if (agreementrequest.lastInvoiceDate) {
      <button matSuffix
              mat-icon-button
              (click)="clearDate($event, LastInvoiceInputDate)">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    <mat-datepicker #LastDatePicker></mat-datepicker>
    @if(agreementrequest.lastInvoiceDate != null){

    <app-dialog-input-title title="Sidste invoice Værdi"></app-dialog-input-title>
    <input type="number" [(ngModel)]="agreementrequest.lastInvoiceValue" />
    }
    <app-dialog-input-title title="Næste invoice Dato"></app-dialog-input-title>
    <mat-form-field (click)="NextDatePicker.open()">
      <mat-label>Vælg dato</mat-label>
      <input matInput
             [matDatepicker]="NextDatePicker"
             [(ngModel)]="agreementrequest.nextInvoiceDate"
             name="NextInvoiceDate"
             #NextInvoiceInputDate />
      <mat-datepicker-toggle matSuffix
                             [for]="NextDatePicker"></mat-datepicker-toggle>
      @if (agreementrequest.nextInvoiceDate) {
      <button matSuffix
              mat-icon-button
              (click)="clearDate($event, NextInvoiceInputDate)">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    <mat-datepicker #NextDatePicker></mat-datepicker>
    @if(agreementrequest.nextInvoiceDate != null){
    <app-dialog-input-title title="Næste invoice Værdi"></app-dialog-input-title>
    <input type="number" [(ngModel)]="agreementrequest.nextInvoiceValue" />
    }
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="agreementrequest.clientId == 0"
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin &&
    agreementrequest.id > 0) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
